"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_async_map_1 = require("rxjs-async-map");
var uploadinator = function (probedBlobs$, options) {
    var upload = function (probedBlob) {
        if (!probedBlob.exists) {
            return options.uploader(probedBlob).then(function () { return probedBlob; });
        }
        else {
            return Promise.resolve(probedBlob);
        }
    };
    return probedBlobs$.pipe(rxjs_async_map_1.asyncMap(upload, options.concurrency));
};
exports.uploadinator = uploadinator;
//# sourceMappingURL=uploadinator.js.map